import globals from '../../globlas';
import { _sendWithAxios, _sendWithAxiosBlob, _sendWithAxiosProgress } from '../api';

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API

export const detalhesArquivo = async (idArquivo) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/detalhe-arquivo/${idArquivo}`, 'GET');
}

export const favoritarDocumento = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Favorito/favoritar-documento`, 'POST', data);
}

export const listarFavoritosPorDocumento = async (idUsuario, nomeDocumento, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Favorito/listar-favoritos/${idUsuario}/${nomeDocumento}/10/${pagina}`, 'GET');
}

export const listarFavoritos = async (idUsuario, pagina, ordem) => {
 
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Favorito/listar-favoritos/${idUsuario}/10/${pagina}?orderBy=${ordem?ordem : 'tipo asc, nomeOrdenacao asc'}`, 'GET');
}

export const removerFavorito = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Favorito/remover-favorito`, 'POST', data);
}